/**
 * PURPOSE: Cliente HTTP para reportes estadísticos deportivos desde Instituciones.
 * RESPONSIBILITIES:
 * - Obtener opciones del modal por deporte/evento.
 * - Descargar PDF como blob con filename desde Content-Disposition.
 * - Normalizar errores de deporte no soportado para la UI.
 * COLLABORATORS:
 * - ModalSportStatisticalReport.jsx
 * - InstitucionesArea.jsx
 * NOTES:
 * - El backend usa strategy; para deportes no implementados responde 501.
 * ROUTE: src/area/InstitucionesArea/sportReportsService.js
 */

import axios from 'axios'
import API_BASE_URL from '../../config/config.js'

function extractFilename(headers, fallback) {
    const disposition = headers?.['content-disposition'] || headers?.['Content-Disposition'] || ''
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)

    if (!match?.[1]) return fallback

    try {
        return decodeURIComponent(match[1])
    } catch (_error) {
        return match[1]
    }
}

function normalizeReportError(error) {
    const status = error?.response?.status
    const message = error?.response?.data?.msg || error?.message || 'No se pudo completar la operación.'

    return {
        status,
        unsupported: status === 501,
        message,
    }
}

export async function getSportReportOptions({ idevent, idsport }) {
    try {
        const { data } = await axios.post(`${API_BASE_URL}/sport-reports/statistical/options`, {
            idevent: Number(idevent),
            idsport: Number(idsport),
        })

        return data
    } catch (error) {
        throw normalizeReportError(error)
    }
}

export async function downloadSportStatisticalReportPdf({ idevent, idsport, stages, sections }) {
    try {
        const payload = {
            idevent: Number(idevent),
            idsport: Number(idsport),
            ...(stages !== undefined ? { stages } : {}),
            ...(sections !== undefined ? { sections } : {}),
        }

        const { data, headers } = await axios.post(
            `${API_BASE_URL}/sport-reports/statistical/pdf`,
            payload,
            {
                responseType: 'blob',
                headers: { Accept: 'application/pdf' },
            }
        )

        const filename = extractFilename(
            headers,
            `reporte_estadistico_${idevent}_${idsport}.pdf`
        )

        return { blob: data, filename }
    } catch (error) {
        throw normalizeReportError(error)
    }
}

export function triggerBlobDownload(blob, filename) {
    const url = URL.createObjectURL(blob)
    const link = Object.assign(document.createElement('a'), {
        href: url,
        download: filename,
    })

    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
}
